


























import {
	computed,
	defineComponent,
	PropType,
	reactive,
	watch,
} from '@vue/composition-api';
import { DEFAULT_COUNTRY_CODE, DEFAULT_REGION_CODE } from '@front-app/components/inputs/CountryPickerData';
import cloneDeep from 'clone-deep';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import {
	Association,
	AssociationCreateRequest,
	AssociationWithoutId,
	FullUser,
} from '@front-app/services/UserApi/UserModel';
import PlusButton from '@front-app/components/buttons/PlusButton.vue';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import EditorWrapper from '../../layouts/form/EditorWrapper.vue';
import EditAssociation from './Association.vue';

function toAssociationResponse(inVal: Association | AssociationWithoutId): AssociationCreateRequest {
	return {
		...inVal,
		location: {
			city: inVal.location.city,
			province: inVal.location.provStateRegion || undefined,
			country: inVal.location.country || undefined,
		},
	};
}

function getEmptyAssociation(): AssociationWithoutId {
	return {
		organizationName: '',
		orgType: 'organization.type.allied-health',
		subGroupName: '',
		location: {
			city: '',
			provStateRegion: DEFAULT_REGION_CODE,
			country: DEFAULT_COUNTRY_CODE,
		},
	};
}

export default defineComponent({
	components: {
		EditorWrapper,
		EditAssociation,
		PlusButton,
	},
	props: {
		user: {
			type: Object as PropType<FullUser>,
			required: true,
		},
	},
	setup(props) {
		const { update } = CurrentUserStore.actions;
		const initialAssociations = computed(() => props.user.associations);
		const state = reactive({
			associations: [] as Array<Association | AssociationWithoutId>,
		});
		watch(initialAssociations, (curr: Association[]) => {
			state.associations = cloneDeep(curr);
		}, { immediate: true });

		const updateAssociation = (index: number, newAssociation: Association | AssociationWithoutId) => {
			Object.assign(state.associations[index], newAssociation);
		};

		const deleteAssociation = (index: number) => {
			state.associations.splice(index, 1);
		};

		const addAssociation = () => {
			state.associations = [getEmptyAssociation(), ...state.associations];
		};

		const {
			track,
			clear,
			isLoading,
			isError,
			isSuccess,
		} = useAsyncStatus();
		const saveUser = async () => {
			await track(update({
				associations: state.associations.map(toAssociationResponse),
			}));
			clear(4000);
		};
		return {
			state,
			updateAssociation,
			deleteAssociation,
			addAssociation,
			// Saving...
			saveUser,
			isLoading,
			isError,
			isSuccess,
		};
	},
});
